import { render, staticRenderFns } from "./ProductLabelBox.vue?vue&type=template&id=024b89da&scoped=true&"
import script from "./ProductLabelBox.vue?vue&type=script&lang=js&"
export * from "./ProductLabelBox.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelBox.vue?vue&type=style&index=0&id=024b89da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024b89da",
  null
  
)

export default component.exports